import React from "react";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { useTheme, Divider, Chip, Button } from "@mui/material";

import { signUp } from "../../helpers/firebase";

import SimpleBox from "../../components/layout/container/SimpleBox";
import PasswordInput from "../../components/input/text/PasswordInput";
import EmailInput from "../../components/input/text/EmailInput";
import DefaultLink from "../../components/link/DefaultLink";
import GoogleButton from "../../components/input/button/GoogleButton";
import TextInput from "../../components/input/text/TextInput";
import UserContainer from "../../components/layout/container/UserContainer";
import { validateEmail, validatePassword } from "../../helpers/validation";

const Register = () => {

    const navigate = useNavigate();
    const theme = useTheme();

    const [name, setName] = React.useState(null);
    const [email, setEmail] = React.useState(null);
    const [password, setPassword] = React.useState(null);
    const [passwordConfirmation, setPasswordConfirmation] = React.useState(null);
    const [errors, setErrors] = React.useState({name: null, email: null, password: null, passwordConfirmation: null});

    const validate = () => {
        const newErrors = {
            name: (name === null || name === "") ? "O nome é um campo obrigatório" : null,
            email: validateEmail(email),
            password: validatePassword(password),
            passwordConfirmation: passwordConfirmation !== password ? "As passwords não coincidem" : null,
        };
        setErrors(newErrors);
        if (newErrors.name !== null || newErrors.email !== null || newErrors.password !== null || newErrors.passwordConfirmation !== null) { return false; }
        return true;
    }

    const handleSubmit = () => {
        const err = validate();
        if (!err) { return; }

        signUp(name, email, password, ({ user, error }) => {
            if (error === null) {
                navigate("/verify-email");
                window.location.reload();
            } else {
                let message = "";
                switch (error.code) {
                    case "auth/email-already-in-use":
                        message = "O email já está a ser utilizado por outra conta.";
                        break;
                    case "auth/invalid-email":
                        message = "O email não é válido.";
                        break;
                    case "auth/operation-not-allowed":
                        message = "O email e a password não estão ativos.";
                        break;
                    case "auth/weak-password":
                        message = "A password é muito fraca.";
                        break;
                    default:
                        message = "Ocorreu um erro ao criar a conta. Por favor, tente novamente mais tarde ou contacte-nos.";
                        break;
                }
                toast.error(message);
            }
        });
    }

    return (
        <UserContainer
            title="Criar Conta"
            message="Crie uma conta no site da ADCB para começar a utilizar todas as funcionalidades de sócio ou de atleta."
        >
            <SimpleBox gap={4} flexDirection="column" mt={6} alignItems="left">
                <TextInput
                    value={name}
                    errorText={errors.name}
                    onChange={(e) => {
                        setName(e.target.value);
                        setErrors({...errors, name: null});
                    }}
                    label="Nome" />
                <EmailInput
                    value={email}
                    errorText={errors.email}
                    onChange={(e) => {
                        setEmail(e.target.value);
                        setErrors({...errors, email: null});
                    }} />
                <PasswordInput
                    value={password}
                    errorText={errors.password}
                    onChange={(e) => {
                        setPassword(e.target.value);
                        setErrors({...errors, password: null});
                    }} />
                <PasswordInput
                    value={passwordConfirmation}
                    errorText={errors.passwordConfirmation}
                    onChange={(e) => {
                        setPasswordConfirmation(e.target.value);
                        setErrors({...errors, passwordConfirmation: null});
                    }}
                    id="password-confirmation"
                    label="Confirmar Palavra Passe" />
                <Button variant="contained" color="primary" fullWidth={true} onClick={handleSubmit}>Registar</Button>
                <SimpleBox justifyContent="right">
                    <DefaultLink label="Já tenho Conta" to="/login" fontSize="0.95rem" allCaps={true} />
                </SimpleBox>
            </SimpleBox>
            <Divider sx={{ marginY: theme.spacing(4)}}>
                <Chip label="OU" size="small" />
            </Divider>
            <GoogleButton />
        </UserContainer>
        
    );
};

export default Register;
